import { useStaticQuery, graphql } from "gatsby";
import { useMemo } from "react";

export type Expert = {
  id: string;
  linkedinUrl: string;
  name: string;
  role: string;
  picture: string;
};

export const useExperts = (filter: string[]) => {
  const { experts } = useStaticQuery<{
    experts: {
      nodes: Expert[];
    };
  }>(graphql`
    query {
      experts: allExpertsJson(sort: { fields: order }) {
        nodes {
          id
          linkedinUrl
          name
          role
          picture
        }
      }
    }
  `);

  return useMemo(
    () =>
      filter
        ? experts.nodes.filter((expert) => filter.includes(expert.name))
        : experts.nodes,
    [experts, filter],
  );
};
